import {
  Box,
  BreakPoints,
  Button,
  CartContainer,
  CartItem,
  CartItemSumary,
  CartItemThumb,
  CartPrice,
  CartSummaryLine,
  DropDown,
  H2,
  Inline,
  MicroSummaryItem,
  MicroSummaryItemDesc,
  ResponsiveContainer,
  RoundedImage,
  Shell,
  ShellScrollContainer,
  Stack,
  ViewPort,
} from "bossfotos-design-system";
import { CircularProgress, Snackbar } from "@material-ui/core";
import { Trolley, TrolleyPhotograph } from "../../types/backend";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import AlertDialog from "../../v2_components/AlertDialog";
import { CurrencyValue } from "../../v2_components/CurrencyValue";
import type { DropDownOption } from "bossfotos-design-system";
import MuiAlert from "@material-ui/lab/Alert";
import { NavBar } from "../trolley/NavBar";
import { SquarePayment } from "../../utils/SquarePayment";
import { RevolutPayment } from "../../utils/RevolutPayment";
import { authenticatedTrolleyList } from "../../v2_actions/authenticated_trolley";
import { setTrolleyID } from "../../actions/trolley"
import { getUserLastName, getUserEmail } from "../../actions/user"
import { basePhotographList } from "../../v2_actions/customer_photograph";
import { countryList } from "../../v2_actions/country";
import { green } from "@material-ui/core/colors";
import { http } from "../../lib";
import { makeLogger } from "../../utils/o11y/logger";
import { photographerList } from "../../v2_actions/photographer";
import { bpointTrolley } from "../../v2_actions/bpoint_trolley";
import { yocoTrolley } from "../../v2_actions/yoco_trolley";
import { setMessage, clearMessage } from "../../actions/trolley";
import styles from "./TrolleyScreen.module.css";
import { trolleyList } from "../../v2_actions/trolley";
import { trolleyPhotographList } from "../../v2_actions/trolley_photograph";
import { trolleyProcessPayment } from "../../v2_actions/trolley_process_payment";
import { useReduxStateReconcilation } from "../../v2_components/hooks/useReduxStateReconcilation";
import { useSelector } from "react-redux";
import { useThunkDispatch } from "../../hooks/useThunkDispatch";
import useTrolleyState from "../../hooks/useTrolleyState";
import { sentryApi } from "../../utils/o11y/sentryApi";
import Delete from "@mui/icons-material/Delete";
import { useIsMobile } from "../../actions/ui";
import VoucherCodeModal from "./VoucherCodeModal";
import GratuityModal from "./GratuityModal";
import { percentageIncrease, amountInCents, percentageOf } from "../../v2_actions/math_utils";
import { useSetPageTitle } from "../../hooks/usePageTitle";

const logger = makeLogger({
  enabled: true,
  label: "TrolleyScreen",
  color: "orange",
});

const ENABLE_VOUCHERS = true;

function Alert(props: any) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const qualityOptions = (photograph: TrolleyPhotograph) => {
  const options: DropDownOption[] = [];
  if (photograph.base_price !== null) {
    options.push({
      value: "high-res",
      label: "High Resolution Digital Photo",
    });
  }
  if (photograph.low_res_price !== null) {
    options.push({
      value: "low-res",
      label: "Low Resolution Digital Photo",
    });
  }
  return options;
};

const TrolleyScreen = () => {
  useReduxStateReconcilation();
  const dispatch = useThunkDispatch();
  const navigate = useNavigate();
  useSetPageTitle(`Checkout`);
  const { trolley_id: trolleyIdFromUrl } = useParams();
  const trolley = trolleyList.getObject(trolleyIdFromUrl) as Trolley;

  logger.log("redirector", { trolleyIdFromUrl }, trolley?.id);
  useEffect(() => {
    dispatch(trolleyList.ensureObjectLoaded(trolleyIdFromUrl))
    dispatch(authenticatedTrolleyList.ensureObjectLoaded(trolleyIdFromUrl))
  }, [trolleyIdFromUrl]);

  const handleHomeClicked = () => {
    navigate("/customer/events/");
  };

  if (!trolley?.id || !trolleyIdFromUrl) {
    return (
      <ViewPort>
        <Shell>
          <NavBar onHomeClicked={handleHomeClicked} />

          <CartContainer>
            <CircularProgress
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                width: 60,
                height: 60,
                color: green[500],
                zIndex: 999,
              }}
            />
          </CartContainer>
        </Shell>
      </ViewPort>
    );
  }

  if (trolley?.id && trolley?.is_purchased) {
    return (
      <ViewPort>
        <Shell>
          <NavBar onHomeClicked={handleHomeClicked} />
          <CartContainer>
            <H2>Your trolley has expired</H2>
            <p>Please can you close your browser and start again</p>
          </CartContainer>
        </Shell>
      </ViewPort>
    );
  }

  return <TrolleyScreenInner />;
};

const trimVoucherCode = (code?: string) => {
  if (!code) return "";

  if (code.length > 15) {
    return code.substring(0, 15) + "xxx";
  }

  return code;
};
const TrolleyScreenInner = () => {
  useReduxStateReconcilation();
  // @ts-ignore
  const message = useSelector((state) => state.trolleyReducer.message);
  const dispatch = useThunkDispatch();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const trolleyState = useTrolleyState();
  const { trolley_id: trolleyIdFromUrl } = useParams();
  const [params] = useSearchParams();
  const cartreturn = params.get("cartreturn");
  const [disableCheckoutButton, setDisableCheckoutButton] = useState(false);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [showVoucherModal, setVoucherModal] = useState(false);
  const [voucherCode, setVoucherCode] = useState(
    sessionStorage.getItem("vouchercode") ?? "",
  );
  const [showGratuityModal, setShowGratuityModal] = useState(false)
  // @ts-ignore
  const lastName = useSelector((state) => getUserLastName(state))
  // @ts-ignore
  const email = useSelector((state) => getUserEmail(state))

  const [showPostPurchaseRedirectMessage, setShowPostPurchaseRedirectMessage] =
    useState(false);
  const [showingSquarePaymentGateway, setShowingSquarePaymentGateway] = useState(false)
  const [showingRevolutPaymentGateway, setShowingRevolutPaymentGateway] = useState(false)

  const [callHandlePayment, setCallHandlePayment] = useState(false)
  const [totalPriceOwingByCustomer, setTotalPriceOwingByCustomer] = useState(-1)

  const galleryCurrencyCode = countryList.getCurrencyCode(
    trolleyState.trolley?.country,
  );
  const indexedGalleryId = basePhotographList.getFilter()?.indexed_gallery_id;

  const facialRecognitionGalleryIdMatchesGalleryId =
    indexedGalleryId === trolleyState.trolley?.gallery;

  useEffect(() => {
    if (trolleyIdFromUrl) {
      dispatch(setTrolleyID(trolleyIdFromUrl))
    } else {
      dispatch(authenticatedTrolleyList.ensureTrolleyLoaded());
    }
  }, [trolleyIdFromUrl]);

  useEffect(() => {
    dispatch(photographerList.loadAllPhotographers());
    dispatch(authenticatedTrolleyList.invalidateObject(trolleyIdFromUrl));
    dispatch(authenticatedTrolleyList.updatePaginationNumItemsPerPage(1));
    dispatch(authenticatedTrolleyList.ensureObjectLoaded(trolleyIdFromUrl));
    dispatch(authenticatedTrolleyList.trySetTrolleyCustomer());
    dispatch(authenticatedTrolleyList.fetchListIfNeeded());
  }, []);

  useEffect(() => {
    dispatch(trolleyList.ensureTrolleyLoaded());
    if (facialRecognitionGalleryIdMatchesGalleryId) {
      dispatch(basePhotographList.clearListFilter());
    }
  }, []);

  useEffect(() => {
    dispatch(clearMessage());
    return () => {
      dispatch(clearMessage());
    };
  }, []);

  useEffect(() => {
    if (totalPriceOwingByCustomer >= 0 && callHandlePayment) {
      handlePayment()
    }
  }, [callHandlePayment, totalPriceOwingByCustomer])

  const redirectBackFromTrolley = async () => {
    logger.log("redirectBackFromTrolley", cartreturn, trolleyState.trolley);
    if (cartreturn) {
      navigate(cartreturn);
      return;
    }

    const trolley_photographs = trolleyState.trolley?.trolley_photographs ?? [];

    if (trolley_photographs.length > 0) {
      const last = trolley_photographs[trolley_photographs.length - 1];
      const galleryId = last.photograph.gallery;
      const [response] = await http.get(`customer/gallery/${galleryId}/`);
      logger.log("redirectBackFromTrolley", galleryId, response);

      if (response.db_id) {
        navigate(
          `/customer/gallery/${(response.gallery_album_name ?? response.session_name).replace(/\s/g, "-")}/${response.db_id}`,
        );
        return;
      }
    }

    // empty cart, can't detect
    navigate("/customer/events");
  };

  const handleBackClicked = () => {
    redirectBackFromTrolley();
  };

  const handleContinueShoppingClick = async () => {
    redirectBackFromTrolley();
  };

  const handleHomeClicked = () => {
    navigate("/customer/events/");
  };

  const handleAddVoucherCodeClicked = () => {
    setVoucherModal(true);
  };

  const handleVoucherCodeModalClosed = (code?: string | undefined) => {
    setVoucherModal(false);
    if (code !== undefined) {
      const trimmedCode = code.trim();
      setVoucherCode(trimmedCode);
      if (!trimmedCode) {
        sessionStorage.removeItem("vouchercode");
      }
      dispatch(
        authenticatedTrolleyList.tryVoucherCode({
          code: trimmedCode,
          onStaleCodeError: (errorCode?: string) => {
            setOpenSnackBar(true);
            if (errorCode === "voucher_used") {
              onMessage("Voucher used");
            } else {
              onMessage("Invalid code");
            }
            setVoucherCode("");
          },
        }),
      );
    }
  };

  const handleGratuityModalClosed = (gratuityPercentage?: number | undefined) => {
    setShowGratuityModal(false)
    setTotalPriceOwingByCustomer(percentageIncrease(
      trolleyState?.totalPriceOwingByCustomer, gratuityPercentage
    ))
    const trolleyID = trolleyState.trolley?.id
    const gratuityAmount = percentageOf(
      trolleyState?.totalPriceOwingByCustomer, gratuityPercentage
    )
    setShowSpinner(true);
    dispatch(trolleyList.saveObject({ id: trolleyID, gratuity_amount: gratuityAmount })
      // @ts-ignore
    ).then((response) => {
      setShowSpinner(false);
      if (response.errors) {
        setCallHandlePayment(false)
        setDisableCheckoutButton(false)
        onMessage("Error adding gratuity")
      } else {
        setCallHandlePayment(true)
      }
    })
  };

  const handleRemovePhoto = (trolleyPhoto: TrolleyPhotograph) => {
    // not working because trolley_photograph uses non
    // authenticated list
    dispatch(
      trolleyPhotographList.removePhotograph(trolleyPhoto.photograph.id),
    );
  };

  const handleQualityChanged = async (
    photograph: TrolleyPhotograph,
    value: string,
  ) => {
    const payload = {
      copy_to_remaining_photographs: photograph.copy_to_remaining_photographs,
      country_print_price: photograph.country_print_price,
      id: photograph.id,
      photo_delivery_type: photograph.photo_delivery_type,
      quality: value,
      trolley: photograph.trolley,
      trolley_photograph_form: true,
    };

    logger.log("change photo quality", payload);

    const res = await dispatch(trolleyPhotographList.saveObject(payload));

    logger.log("change photo quality res=>", res);

    dispatch(trolleyList.invalidateObject(trolleyState.trolley?.id));
    dispatch(trolleyList.ensureObjectLoaded(trolleyState.trolley?.id));
    dispatch(
      authenticatedTrolleyList.invalidateObject(trolleyState.trolley?.id),
    );
    dispatch(
      authenticatedTrolleyList.ensureObjectLoaded(trolleyState.trolley?.id),
    );
  };

  logger.log(trolleyState, { cartreturn });

  const onMessage = (msg: string) => {
    dispatch(setMessage(msg));
    if (msg) {
      setShowSpinner(false);
      setOpenSnackBar(true);
    }
  };

  const createFakePayment = () => {
    setShowPostPurchaseRedirectMessage(true);
    dispatch(
      trolleyProcessPayment.pay({
        trolley_id: trolleyState.trolley?.id,
        gateway_payment_ref: null,
        total_price_paid_by_customer: totalPriceOwingByCustomer,
      }),
      // @ts-ignore
    ).then(onPaymentSuccessfulAndConfirmed);
  };

  const onPaymentSuccessfulAndConfirmed = () => {
    logger.log("onPaymentSuccessfulAndConfirmed");
    setShowSpinner(false);
    dispatch(authenticatedTrolleyList.resetTrolley());
    navigate("/customer/purchased");
  };

  const checkOutYoco = async () => {
    if (totalPriceOwingByCustomer <= 2) {
      createFakePayment();
    } else {
      setShowSpinner(true)
      dispatch(
        yocoTrolley.prepareOrder({
          trolley_id: trolleyState.trolley?.id,
          total_price: amountInCents(totalPriceOwingByCustomer)
        }),
      )
      // @ts-ignore
        .then((res) => {
          if (res.status === 'success') {
            const redirectUrl = res.results.redirect_url;
            window.location.href = redirectUrl;
          } else {
            console.error(res.error);
            sentryApi.error('yoco_checkout_error', res.error);
            setOpenSnackBar(true);
            onMessage('Payment preparation failed');
            setDisableCheckoutButton(false);
            setShowSpinner(false);
          }
        });
    }
  };

  const checkOutBpoint = () => {
    if (totalPriceOwingByCustomer <= 2) {
      createFakePayment();
    } else {
      setShowSpinner(true)
      dispatch(
        bpointTrolley.prepareOrder({
          trolley_id: trolleyState.trolley?.id,
          total_price: amountInCents(totalPriceOwingByCustomer)
        }),
      )
      // @ts-ignore
        .then((res) => {
          if (res.status === 'success') {
            const hostedPaymentPageUrl = res.results.hosted_payment_page_url;
            window.location.href = hostedPaymentPageUrl;
          } else {
            console.error(res.error);
            sentryApi.error("bpoint_checkout_error", res.error);
            setOpenSnackBar(true);
            onMessage("Payment preparation failed");
            setDisableCheckoutButton(false);
            setShowSpinner(false);
          }
        })
        .catch((err: any) => {
          console.error(err);
          sentryApi.error("bpoint_checkout_error", err);
          setOpenSnackBar(true);
          onMessage("Payment preparation failed");
          setDisableCheckoutButton(false);
          setShowSpinner(false);
        });
    }
  };

  const checkOutSquare = () => {
    if (totalPriceOwingByCustomer <= 2) {
      createFakePayment();
    } else {
      setShowingSquarePaymentGateway(true);
    }
  };

  const checkOutRevolut = () => {
    if (totalPriceOwingByCustomer <= 2) {
      createFakePayment();
    } else {
      setShowingRevolutPaymentGateway(true);
    }
  };

  const handleCheckoutClick = async () => {
    setDisableCheckoutButton(true);
    if (trolleyState.trolley?.id && trolleyState.totalPriceOwingByCustomer >= 0) {
      logger.log(
        "handleCheckoutClick",
        trolleyState.paymentGateway,
        trolleyState.trolley?.id,
      );
      if (trolleyState.trolley?.allow_gratuity) {
        setShowGratuityModal(true)
      } else {
        setTotalPriceOwingByCustomer(trolleyState.totalPriceOwingByCustomer)
        setCallHandlePayment(true)
      }
    } else {
      navigate(`/customer/events`);
    }
  };

  const handlePayment = async () => {
    setCallHandlePayment(false)
    if (totalPriceOwingByCustomer < trolleyState?.totalPriceOwingByCustomer) {
      onMessage(
        "Payment preparation failed, invalid amount"
      )
      setDisableCheckoutButton(false)
      return
    }

    switch (trolleyState.paymentGateway) {
      case "yoco":
        checkOutYoco();
        break;
      case "bpoint":
        checkOutSquare();
        break;
      case "simplify":
        checkOutSquare();
        break;
      case "square":
        checkOutSquare();
        break;
      case "revolut":
        checkOutRevolut();
        break;
      default:
        sentryApi.error("trolley_no_payment_gateway", {
          paymentGateway: trolleyState?.paymentGateway,
          ...trolleyState?.trolley,
        });
        console.error(
          `Unknown payment gateway: ${trolleyState.paymentGateway}`,
        );
        onMessage(
          "Payment preparation failed, couldn't find payment gateway",
        );
        break;
    }
  }

  const onCloseSquarePaymentGateway = () => {
    setShowingSquarePaymentGateway(false)
    setDisableCheckoutButton(false)
  }

  const onCloseRevolutPaymentGateway = () => {
    setShowingRevolutPaymentGateway(false)
    setDisableCheckoutButton(false)
  }

  return (
    <ViewPort>
      <Shell>
        <Snackbar
          open={openSnackBar}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={() => setOpenSnackBar(false)}
        >
          <Alert onClose={() => setOpenSnackBar(false)} severity="error">
            {message}
          </Alert>
        </Snackbar>

        {showVoucherModal && (
          <VoucherCodeModal
            code={voucherCode}
            onClose={handleVoucherCodeModalClosed}
          />
        )}
        {showGratuityModal && (
          <GratuityModal
            onClose={handleGratuityModalClosed}
          />
        )}
        <NavBar
          onBackClicked={handleBackClicked}
          onHomeClicked={handleHomeClicked}
        />
        <ShellScrollContainer>
          <ResponsiveContainer
            breakpoints={{
              [BreakPoints.sm]: Stack,
              [BreakPoints.md]: Inline,
            }}
          >
            <Box
              width="auto"
              widthmd="570px"
              stylesm={{ order: 3 }}
              stylemd={{ order: 1 }}
            >
              <Stack>
                {(trolleyState.trolley?.trolley_photographs?.length ?? 0) ===
                  0 && (
                  <div className={styles.centered}>
                    <H2>Empty Cart</H2>
                    <p>Add photos to purchase</p>
                  </div>
                )}
                {trolleyState.trolley?.trolley_photographs?.map(
                  (photograph) => (
                    <>
                      <CartItem
                        key={`trolley-cartitem-${photograph.id}`}
                        style={isMobile ? {} : { paddingRight: "10px" }}
                      >
                        <CartItemThumb
                          style={{
                            width: isMobile ? "auto" : "auto",
                            marginBottom: isMobile ? "10px" : "0px",
                          }}
                        >
                          <RoundedImage>
                            <img
                              src={
                                (photograph.photograph.gallery_size_file_info as any)?.content_type?.startsWith("video/")
                                  ? (photograph.photograph as any).thumbnail_size_file_info?.download_url
                                  : photograph.photograph.gallery_size_file_info?.download_url
                              }
                            />
                          </RoundedImage>
                        </CartItemThumb>
                        <CartItemSumary>
                          <MicroSummaryItem>
                            <MicroSummaryItemDesc
                              justifyContent={isMobile ? "center" : "flex-end"}
                            >
                              <DropDown
                                width="260px"
                                options={qualityOptions(photograph)}
                                disabled={trolleyState.isUpdating}
                                onSelected={(option) =>
                                  handleQualityChanged(photograph, option.value)
                                }
                                selectedValue={photograph.quality}
                                renderDropDownOption={(option) => {
                                  return (
                                    <>
                                      {option.label}{" "}
                                      <CurrencyValue
                                        country={
                                          trolleyState.photographer.country
                                        }
                                        value={
                                          option.value === "low-res"
                                            ? photograph.low_res_price
                                            : photograph.base_price
                                        }
                                        horizontal_spacing={false}
                                      />
                                    </>
                                  );
                                }}
                              />
                            </MicroSummaryItemDesc>
                          </MicroSummaryItem>
                          <ResponsiveContainer
                            style={{ marginTop: "10px" }}
                            breakpoints={{
                              [BreakPoints.sm]: Inline,
                              [BreakPoints.md]: Stack,
                            }}
                          >
                            <MicroSummaryItem
                              flexGrow={2}
                              style={{ flexGrow: 2 }}
                            >
                              <MicroSummaryItemDesc
                                justifyContent={
                                  isMobile ? "flex-start" : "flex-end"
                                }
                                alignItems={isMobile ? "center" : ""}
                              >
                                <CartPrice>
                                  Item Price{" "}
                                  <CurrencyValue
                                    country={trolleyState.photographer.country}
                                    value={
                                      photograph.quality === "high-res"
                                        ? photograph.base_price
                                        : photograph.low_res_price
                                    }
                                    horizontal_spacing={false}
                                  />
                                </CartPrice>
                              </MicroSummaryItemDesc>
                            </MicroSummaryItem>
                            <MicroSummaryItem flexGrow={2}>
                              <MicroSummaryItemDesc
                                justifyContent="flex-end"
                                alignItems={isMobile ? "center" : ""}
                              >
                                <Button
                                  style={{ marginRight: "-4px" }}
                                  variant="link"
                                  collapsePadding={true}
                                  onClick={() => handleRemovePhoto(photograph)}
                                  disabled={trolleyState.isUpdating}
                                >
                                  Remove <Delete />
                                </Button>
                              </MicroSummaryItemDesc>
                              <div
                                className={styles.microsummaryitemaction}
                              ></div>
                            </MicroSummaryItem>
                          </ResponsiveContainer>
                        </CartItemSumary>
                      </CartItem>
                    </>
                  ),
                )}
              </Stack>
            </Box>
            <div style={{ order: 2, flexGrow: 2 }}></div>
            <Box
              width="auto"
              widthmd="530px"
              style={isMobile ? { backgroundColor: "#EDEDED" } : {}}
              stylesm={{ order: 1 }}
              stylemd={{ order: 3 }}
            >
              <Box
                style={isMobile ? {} : { backgroundColor: "#EDEDED" }}
                variantsm={"empty"}
                variantmd={"primary"}
              >
                <H2>Summary</H2>
                <hr />
                <CartSummaryLine>
                  <div>
                    Total Items - {trolleyState.trolley?.number_of_photos}
                  </div>
                  <div>
                    <CurrencyValue
                      country={trolleyState.trolley?.country}
                      value={trolleyState.trolley?.total_photograph_price}
                      horizontal_spacing={false}
                    />
                  </div>
                </CartSummaryLine>
                <CartSummaryLine>
                  <div>Bulk Discounts</div>
                  <div>
                    <CurrencyValue
                      country={trolleyState.trolley?.country}
                      value={trolleyState.trolley?.bulk_discount}
                      horizontal_spacing={false}
                      isNegative={true}
                    />
                  </div>
                </CartSummaryLine>
                <CartSummaryLine>
                  <div>Admin Fee</div>
                  <div>
                    <CurrencyValue
                      country={trolleyState.trolley?.country}
                      value={trolleyState.trolley?.admin_charge}
                      horizontal_spacing={false}
                    />
                  </div>
                </CartSummaryLine>
                {ENABLE_VOUCHERS && (
                  <CartSummaryLine>
                    <div>
                      <Inline>
                        <>Voucher</>
                        <div
                          style={{
                            flexGrow: 2,
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          <Button
                            variant="secondary"
                            size="small"
                            onClick={handleAddVoucherCodeClicked}
                          >
                            {!voucherCode
                              ? "Add voucher number"
                              : trimVoucherCode(voucherCode)}
                          </Button>
                        </div>
                        <CurrencyValue
                          country={trolleyState.trolley?.country}
                          value={trolleyState.trolley?.voucher_discount ?? 0}
                          horizontal_spacing={false}
                          isNegative={true}
                        />
                      </Inline>
                    </div>
                  </CartSummaryLine>
                )}
                <hr />
                <CartSummaryLine primary={true}>
                  <div>
                    <b>
                      Total Price in{" "}
                      {trolleyState.photographerCountry?.currency_name}
                    </b>
                  </div>
                  <div>
                    <CurrencyValue
                      country={trolleyState.trolley?.country}
                      value={
                        trolleyState.trolley?.total_price_owing_by_customer
                      }
                      horizontal_spacing={false}
                    />
                  </div>
                </CartSummaryLine>
                <Stack alignItems="center">
                  <div style={{ height: "20px" }}></div>
                  <Button
                    style={{ width: "320px", marginBottom: "10px" }}
                    disabled={disableCheckoutButton || trolleyState.isUpdating}
                    onClick={handleCheckoutClick}
                  >
                    Checkout
                  </Button>
                  <Button
                    variant={"link"}
                    style={{ width: "320px" }}
                    onClick={handleContinueShoppingClick}
                  >
                    Continue Shopping
                  </Button>
                  <div style={{ height: "20px" }}></div>
                </Stack>
              </Box>
            </Box>
          </ResponsiveContainer>
        </ShellScrollContainer>
      </Shell>
      {(showSpinner || trolleyState.isLoading) && (
        <CircularProgress
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: 60,
            height: 60,
            color: green[500],
            zIndex: 999,
          }}
        />
      )}
      {showingSquarePaymentGateway && (
        <SquarePayment
          onClose={() => onCloseSquarePaymentGateway()}
          trolley={trolleyState.trolley}
          totalPriceOwingByCustomer={totalPriceOwingByCustomer}
          onPaymentSuccessfulAndConfirmed={onPaymentSuccessfulAndConfirmed}
          onPaymentFailure={(msg: string) => {
            setShowingSquarePaymentGateway(false);
            setShowSpinner(false);
            onMessage(msg);
            setDisableCheckoutButton(false);
          }}
        />
      )}
      {showingRevolutPaymentGateway && (
        <RevolutPayment
          onClose={() => onCloseRevolutPaymentGateway()}
          totalPriceOwingByCustomer={totalPriceOwingByCustomer}
          galleryCurrencyCode={galleryCurrencyCode}
          trolleyId={trolleyState.trolley?.id}
          lastName={lastName}
          email={email}
          setOpenSnackBar={setOpenSnackBar}
          onMessage={onMessage}
          setDisableCheckoutButton={setDisableCheckoutButton}
          onPaymentSuccessfulAndConfirmed={onPaymentSuccessfulAndConfirmed}
        />
      )}
      {showPostPurchaseRedirectMessage && (
        <AlertDialog
          allowClose={false}
          disablePortal={false}
          openAlertDialog={showPostPurchaseRedirectMessage}
          setOpenAlertDialog={setShowPostPurchaseRedirectMessage}
          heading="Thank you for your purchase."
          body="Please be patient. We are creating your photos and will redirect you. Please don't click on anything while this happens. Thanks"
          actions={undefined}
        />
      )}
    </ViewPort>
  );
};

export default TrolleyScreen;
